// extracted by mini-css-extract-plugin
export var chip = "_3x-9";
export var chipLabel = "_3x-a";
export var close = "_3x-7";
export var closeIcon = "_3x-8";
export var error = "_3x-6";
export var infoTooltip = "_3x-2";
export var innerContainer = "_3x-1";
export var input = "_3x-b";
export var medium = "_3x-5";
export var outerContainer = "_3x-0";
export var small = "_3x-4";
export var xSmall = "_3x-3";